module.exports = __webpack_public_path__ + "static/diy_recipe_crocodile_cookies_thumbnail-25f3a4efde39238ff88e70ac1fd4eb70.jpg";